export async function openTripAgentThread({ trip, api, navigate }) {
  if (!trip?.id) {
    throw new Error('Trip is required');
  }
  if (trip.inquiry_id) {
    navigate(`/my-inquiries/${trip.inquiry_id}`);
    return { inquiryId: trip.inquiry_id, created: false };
  }
  const response = await api.post(`/package-booking/trips/${trip.id}/thread`);
  const inquiryId = response.data?.inquiryId;
  if (!inquiryId) {
    throw new Error('Failed to open messages with the agent');
  }
  navigate(`/my-inquiries/${inquiryId}`);
  return { inquiryId, created: Boolean(response.data.created) };
}
